enum PublicationContentFormatType {
    Xml = 1,
    Image = 2,
}

export default PublicationContentFormatType;
